import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import axios from "axios";
// import LoadingSpinner from './dev/LoadingSpinner'
import CheckIcon from './icon/CheckIcon'
import EyeIcon from './icon/Eye'
import EditIcon from './icon/EditIcon'
import RemoveIcon from './icon/Cross'
import convertDate from './dev/convertDate';
import PaymentBanner from './Payment/PaymentBanner';
import Pagination from './dev/Pagination'
import Search from './dev/Search'
import Select from './dev/Select'
import {categoryList} from './ProposalList/categoryList'

const { REACT_APP_URI = '/' } = process.env
class ProposalList extends Component {
    state={
        condition: {
            page: 0,
            category: "all",
            keyword: "",
        },
        list: [],
        isLoading: true,
        listLength: 1,
        addInputValue: '',
        isAdd: false,
        pageCount: 0,
        currentPage: 0,
        total: 0,
        tmpKeyword: "",
        stauts: 200,
    }
    componentDidMount() {
        this.getProposalList();
    }
    heyPleaseUpgrade = () => {
        this.props.dispatch({ 
            type: 'togglePaymentField', 
            isPaymentGuideActive: true,
            paymentGuideMinPlan: "Agency",
        })
        return
    }
    makeCancelableRequest = () => {
        let call;
        return url => {
            if (call) {
                call.cancel("cancel previous request");
            }
            call = axios.CancelToken.source();
            return axios.get(url, {
                withCredentials: true,
                cancelToken: call.token
            });
        };
    };
    get = this.makeCancelableRequest();
    getProposalList = async () => {
        const { get } = this
        const { condition } = this.state
        this.setState({ isLoading: true })
        let urlArgs = Object.entries(condition)
            .map(pairs => {
                const [key, value] = pairs;
                return `${key}=${value}`;
            })
            .join("&");
        try { // 重複 call cancel
            await get(`${REACT_APP_URI}/api/Proposal/?${urlArgs}&version=2`, { withCredentials: true })
                .then(res => {
                    const { status } = res;
                    this.setState({ status });
                    return res.data;
                })
                .then(res => {
                    const { list } = res 
                    const newList = list.map(i => { return { ...i, isDelete: null, isTitleEdit: false, editedTitle: i.title, } })
                    this.setState({ ...res, list: newList, isLoading: false })
                })
        } catch (err) {
            if (
                err.response !== undefined && (err.response.status === 706 || err.response.status === 707)
            ){
                this.setState({ status: err.response.status, isLoading: false})
            }
            if (axios.isCancel(err)) {
                console.error(`Cancelling previous request: ${err.message}`);
            }
        }
    }
    togglePage = pageValue => {
        this.setState({ currentPage: parseInt(pageValue, 10) - 1, condition: {...this.state.condition, page: parseInt(pageValue, 10) - 1} },
            () => {
                window.scrollTo(0, 0);
                this.getProposalList();
            }
        );
    }
    categorySelect = ({ value = "", label = "" }) => {
        this.setState(
            {
                condition: { ...this.state.condition, category: value, page: 0},
            },
            () => {
                window.scrollTo(0, 0);
                this.getProposalList();
            }
        );
    };
    keywordInput = e => this.setState({ tmpKeyword: e.target.value })
    keywordSubmit = e => {
        const {user:{ plan, auth}} = this.props
        if(auth === "notSignIn") {
            this.props.dispatch({ type: 'toggleUserField', condition: 'signIn'})
            return
        }
        if(plan !== "Agency") {
            this.heyPleaseUpgrade()
            return
        }
        const { tmpKeyword } = this.state
            this.setState({
                condition: {
                    ...this.state.condition,
                    keyword : tmpKeyword,
                    page: 0,
                },
                pageCount: 1,
            },() => {
                this.getProposalList()
        })
    }
    keywordCancel = () => {
        this.setState({
            condition: {
                ...this.state.condition,
                keyword : ""
            },
            tmpKeyword: "",
        },() => {
            this.getProposalList()
    })
    }
    toggleAdd = () => {
        if(this.props.user.plan !== 'Agency') return
        this.setState({ isAdd: !this.state.isAdd })}
    addInput = e => this.setState({ addInputValue: e.target.value })
    addSubmit = () => {
        const { props: { user: { token } }, state: { addInputValue }, getProposalList, toggleAdd} = this
        fetch(`${REACT_APP_URI}/api/Proposal/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify({
                title: addInputValue,
            })
        })
            .then(res => {
                const { status } = res
                if (status === 200) { 
                    getProposalList();
                    toggleAdd();
                }
            })
    }
    toggleDelete = (index, isDelete) => {
        let { list } = this.state
        list.splice(index, 1, { ...list[index], isDelete: isDelete })
        this.setState({ list })
    }
    deleteSubmit = id => {
        const { props: { user: { token } }, getProposalList } = this
        fetch(`${REACT_APP_URI}/api/Proposal/${id}`, {
            method: 'delete',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
        })
            .then(res => {
                const { status } = res
                if (status === 200) {
                    getProposalList();
                }
            })
    }
    toggleTitleEdit = index => {
        let { list } = this.state
        let { isTitleEdit } = list[index]
        list.splice(index, 1, { ...list[index], isTitleEdit: !isTitleEdit })
        this.setState({ list })
    }
    editTitleInput = index => e => {
        let { list } = this.state
        list.splice(index, 1, { ...list[index], editedTitle: e.target.value })        
        this.setState({ list })
    }
    editTitleSubmit = (index) => {
        const { user: { token } } = this.props
        const { getProposalList } = this 
        const { id, editedTitle } = this.state.list[index]
        fetch(`${REACT_APP_URI}/api/Proposal/${id}/`, {
            method: 'put',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify({ 
                title: editedTitle,
            })
        })
        .then(res => {
            const { status } = res
            if (status === 200) getProposalList()
        })
    }
    setChannels = (channels, isMine) => {
        const { renderChannel, renderOtherChannel } = this
        const maxLength = isMine ? 8 : 5
        if (channels === null) return
        else if (channels.length > maxLength) {
            const avatarChannels = channels.slice(0, maxLength)
            //const otherChannels = channels.slice(0, channels.length - maxLength) //這用來顯示 及其他n個人
            const otherChannels = channels.slice(maxLength, channels.length)
            return (
                <React.Fragment>
                    {avatarChannels.map(channle => renderChannel(channle))}
                    {renderOtherChannel(otherChannels)}
                </React.Fragment>
            )
        }
        else {
            return channels.map(channle => renderChannel(channle))
        }
    }
    renderChannel = (channel) => {
        const { title, avatar } = channel
        return (
            <Avatar imgUrl={avatar} creatorTitle={CSS.escape(title)}/>
        )
    }
    renderOtherChannel = (otherChannels) => {
        const { messages } = this.props
        const creatorTitles = otherChannels.map(({ title }) => `${CSS.escape(title)}, `)//hover content 包含引號會爆 
        return (
            <OtherChannels creatorTitles={creatorTitles}>
                <div>{messages.proposal_list_other}</div>
                <div>{otherChannels.length}</div>
                <div>{messages.people}</div>
            </OtherChannels>
        )
    }
    renderDelete = (id, index, title, isDelete) => {
        const { props: { messages }, toggleDelete, deleteSubmit } = this
        return (
            <ProposalDelete isDelete={isDelete}>
                <ProposalDeleteContent isDelete={isDelete}>
                        <span>{messages.proposal_list_confirm_delete}「 {title} 」?</span>
                        <ProposalDeleteRightPart>
                            <span onClick={() => deleteSubmit(id)}>{messages.delete}</span>
                            <span onClick={() => toggleDelete(index, false)}>{messages.cancel}</span>
                        </ProposalDeleteRightPart>
                </ProposalDeleteContent>
            </ProposalDelete>
        )
    }
    renderList = (item, index) => {
        const { id, title, channels, lastEditTime, isTitleEdit, editedTitle, isDelete, owner } = item
        const { setChannels, toggleTitleEdit, editTitleInput, editTitleSubmit, toggleDelete, renderDelete } = this
        const {myEmail} = this.state
        const isMine = myEmail === item.owner
        return (
            <ProposalListWrap>
                <ProposalListContent isMine={isMine}>
                    <LeftPart>
                        {!isTitleEdit && <ProposalTitle>{title}</ProposalTitle>}
                        {isTitleEdit && <ProposalTitleInput
                            autoFocus
                            value={editedTitle}
                            onInput={editTitleInput(index)}
                            onKeyPress={e => e.key === "Enter" && editTitleSubmit(index)}
                        />}
                        <DateWrap>{convertDate(lastEditTime)}</DateWrap>
                    </LeftPart>
                    <CenterPart>{setChannels(channels, isMine)}</CenterPart>
                    <RightPart isMine={isMine}>
                        {!isMine && <ProposalTitle noneBottom>{owner}</ProposalTitle>}
                        <StyledLink to={`/Proposal/${id}`}>                    
                            <IconWrap>
                                <EyeIcon size={12} />
                            </IconWrap>
                        </StyledLink>
                        {isMine && <IconWrap onClick={() => toggleTitleEdit(index)}><EditIcon size={10} /></IconWrap>}
                        {isMine && <IconWrap onClick={() => toggleDelete(index, true)}><RemoveIcon size={10} /></IconWrap>}
                    </RightPart>
                </ProposalListContent>
                {isMine && renderDelete(id, index, title, isDelete)}
            </ProposalListWrap>
        )
    }
    renderLoading = () => {
        const { state: { listLength } } = this
        const loadingList = Array.from({ length: listLength } )
        const loadingCreators = Array.from({ length: 8 })
        return loadingList.map(() => {
            return (
                <ProposalListContent>
                    <LeftPart>
                        <ProposalTitle isLoading />
                    </LeftPart>
                    <CenterPart>
                        {loadingCreators.map(() => <Avatar isLoading/>)}
                    </CenterPart>
                    <RightPart>
                    </RightPart>
                </ProposalListContent>
            )
        })
    }
    renderTitleArea = () => {
        const {messages} = this.props
        const { 
            state: { tmpKeyword },
            toggleAdd, keywordInput, keywordSubmit,keywordCancel
        } = this
        return (
            <TitleWrap>
                <div>{messages.user_tour_info_10}</div>
                <div>
                    <Search
                        keyword={tmpKeyword}
                        keywordInput={keywordInput} 
                        keywordSubmit={keywordSubmit}
                        keywordCancel={keywordCancel}
                        placeholder={messages.proposal_list_search_name}
                    />
                    <ProposalAddButton onClick={() => toggleAdd()}>{messages.proposal_list_create}</ProposalAddButton>
                </div>
            </TitleWrap>
        )
    }
    renderFilterArea = () => {
        const {currentPage, total, condition:{category}, status} = this.state
        const {messages} = this.props
        const {categorySelect} = this
        const newCategoryList = categoryList.map(i => {return {...i, label: messages[i.label]}})
        const fromValue = currentPage * 25 + 1
        const toValue = (currentPage + 1) * 25 <= total ? (currentPage + 1) * 25 : total
        return (
            <FilterArea>
                <Select
                    value={category}
                    onChange={categorySelect}
                    options={newCategoryList}
                    placeholder={newCategoryList.find(i => i.value === category).label}
                    minWidth="150px"
                />
                {status === 200 && <div>show {fromValue} to {toValue} of {total}</div>}
            </FilterArea>
        )
    }
    renderProposalList = () => {
        const { 
            props: { messages },
            state: { isLoading, list, status },
            renderList, renderLoading, renderFilterArea, renderTitleArea
        } = this
        return (
            <Wrap>
                {renderTitleArea()}
                {renderFilterArea()}
                <Bar/>
                {!isLoading && status === 706 && <ProposalListError isBlank>{messages.info_no_proposal}</ProposalListError>}
                {!isLoading && status === 707 && <ProposalListError isBlank>
                    <div>
                        <span>{messages.info_list_no_result}</span>
                        <span>-{messages.info_list_no_result_adjust_filter}</span>
                        <span>-{messages.rank_no_result_03}</span>
                    </div>
                </ProposalListError>}
                {!isLoading && status === 200 && list.map((item, index) => renderList(item, index))}
                {isLoading && renderLoading()}
            </Wrap>
        )
    }
    renderProposalAdd = () => {
        const {
            props: { messages },
            state: { addInputValue},
            toggleAdd, addInput, addSubmit, 
        } = this
        return (
            <React.Fragment>
                <Mask/>
                <ProposalAdd>
                    <ProposalAddTitle>{messages.proposal_list_create_name}：</ProposalAddTitle>
                    <ProposalAddInput 
                        type={"text"}
                        value={addInputValue}
                        onInput={addInput}
                        onKeyPress={e => e.key === "Enter" && addSubmit()}
                    />
                    <RightPart flex>
                        <IconWrap onClick={() => addSubmit()}><CheckIcon size={10} isCheck/></IconWrap>
                        <IconWrap onClick={() => toggleAdd()}><RemoveIcon size={10} /></IconWrap>
                    </RightPart>
                </ProposalAdd>
            </React.Fragment>
        )
    }
    render() {
        const { state: { isAdd, isLoading, pageCount, currentPage }, props: {messages}, togglePage, renderProposalList, renderProposalAdd } = this
        return (
            <Container>
                {isAdd && renderProposalAdd()}
                {renderProposalList()}
                {!isLoading && pageCount!== 0 && (
                    <Pagination
                        togglePage={togglePage}
                        pageCount={pageCount}
                        currentPage={currentPage}
                        messages={messages}
                    />
                )}
                <PaymentBanner bannerPlan={"Agency"}/>
            </Container>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages,
        payment: state.Payment,
    }
}
export default connect(mapStateToProps)(ProposalList);
const Loading = keyframes`
    0%, 100% {
        opacity: .15;
    }
    50% {
        opacity: .05;
    }
`
const Animationdelete = keyframes`
    0% {
        width: 0;
        opacity: 0;
        color: transparent; 
        word-wrap: normal;
	}
    99% {
        color: transparent;
    }
    100% {
        width: 100%;
        color: #fff;
        opacity: 1
        word-wrap: break-word;
    } 
`;
const Mask = styled.div`
    position: fixed;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 14999;
    background-color: rgba(0,0,0,.6);
    cursor: pointer;
    transition: all 2s ease-in-out;
    overflow: scroll;
`
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: calc(100vh - 72px);
    padding: 50px 0 120px 0;
    background-color: #fafafa;
    border-left: 1px solid #e6e6e6;
    /* overflow: scroll; */
    @media (max-width: 900px){
        align-items: initial;
    } 
`
const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 900px;
    margin-top: 30px;
`
const TitleWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;    
    width: 100%;
    margin-bottom: 10px;
    font-size: 24px;
    font-weight: 500;
    color: #787878;
    div {
        display: flex;
        align-items: center;
    }
`
const ProposalAddButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    padding: 6px 20px;
    margin-left: 15px;
    border-radius: 4px;
    color: #fff;
    font-size: 16px;
    background-color: #e94242;
    white-space: nowrap;
    box-shadow: 1px 2px 2px 0 rgba(153, 153, 153, 0.6);
    cursor: pointer;
`
const ProposalAdd = styled.div`
    position: fixed;
    display: grid;
    grid-template: 1fr / auto 300px 100px;
    align-items: center; 
    min-width: 640px;
    padding: 0 0 0 40px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 15000;
    font-size: 16px;
    font-weight: 300;
    background-color: #fff;
    color: #787878;
    transition: all .2s ease-in-out;
`
const ProposalAddTitle = styled.div`
    font-size: 24px;
    font-weight: 500;
    padding: 10px 0;
`
const ProposalAddInput = styled.input`
    width: 100%;
    padding-left: 5px;
    border: solid 1px #dedede;
    font-size: 14px;
    font-weight: 300;
    color: #999999;
    &:focus {
        border: solid 1px #999999;
        outline: none;
    }
`
const Bar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 20px;
    padding: 0 20px;
    background-color: #e94242;
`
const ProposalListWrap = styled.div`
    position: relative;
    width: 100%;
`
const ProposalListContent = styled.div`
    display: grid;
    grid-template: ${({isMine}) => isMine ? '1fr / 200px auto 96px' : '1fr / 200px auto 300px'};
    width: 100%;
    height: 80px;
    background-color: #fff;
    border-bottom: 1px solid #e6e6e6;
`
const ProposalListError = styled.div`
    display: flex; 
    align-items: center; 
    justify-content: center;
    width: 100%;
    min-height: 80px;
    padding: 20px 0;
    background-color: #fff;
    border-bottom: 1px solid #e6e6e6;
    color: #de0606; 
    font-size: 20px; 
    font-weight: 500;
    div {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
    }
`
const LeftPart = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: auto;        
    padding: 10px 20px;
`
const RightPart = styled.div`
    /* display: grid; */
    ${({ flex }) => flex ? 'display: flex; justify-content: space-around;' : 'display: grid'}
    grid-template: ${({ isMine }) => isMine ? '1fr / 1fr 1fr 1fr' : '1fr / auto 32px'};
    align-items: center;
    /* height: auto; */
    height: 100%;
`
const CenterPart = styled.div`
    display: flex;
    align-items: center;
    height: auto;        
`
const ProposalTitle = styled.div`
    word-wrap: break-word;
    font-size: 14px;
    font-weight: 500;
    color: #666666;
    margin-bottom: ${({ noneBottom }) => noneBottom ? '0' : '8px'};
    ${({ isLoading }) => isLoading ? `height: 1rem; margin-bottom: 0px; border-radius: 8px; background-color: #787878; animation: ${Loading} 2s infinite;` :''}
`
const ProposalTitleInput = styled.input`
    padding-left: 5px;
    border: solid 1px #dedede;
    font-size: 14px;
    font-weight: 300;
    color: #999999;
    margin-bottom: 4px;
    &:focus {
        border: solid 1px #999999;
        outline: none;
    }
`
const DateWrap = styled.div`
    font-size: 10px;
    font-weight: 300;
    color: #666666;
`
const IconWrap = styled.label`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ width }) => width ? width : '32px'};
    height: 100%;
    cursor: pointer;
    &:hover {
        /* background-color: rgba(233,66,66,.8); */
        background-color: #d0d0d0;
        svg, path {
            fill: #fff;
        }
    }
`
const StyledLink = styled(Link)`
    height: 100%;
`
const Avatar = styled.div`
    position: relative;
    border-radius: 100%;
    width: 48px;
    height: 48px;
    margin-right: 10px;
    border-radius: 100%;
    background-image: url('${props => props.imgUrl}');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    ${props => props.isLoading ? `color: transparent; background-image: none; background-color: #787878; animation: ${Loading} 2s infinite;` : ''}
    &:hover:after {
        content: '${props => props.creatorTitle}';
        display: flex;
        justify-content: center;
        position: absolute;
        left: 50%;
        top: 100%;
        transform: translateX(-50%);
        font-size: 14px;
        width: 300%;
        height: auto;
        background: #666;
        color: #fff;
        padding: 5px;
        border-radius: 5px;
        z-index: 999;
        word-break: break-all;
    }
`
const OtherChannels = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 8px;
    &:hover:after {
        content: '${props => props.creatorTitles}';
        display: flex;
        justify-content: center;
        position: absolute;
        left: 50%;
        top: 100%;
        transform: translateX(-50%);
        font-size: 14px;
        width: 300px;
        height: auto;
        background: #666;
        color: #fff;
        padding: 5px;
        border-radius: 5px;
        z-index: 999;
        word-break: break-all;
    }
    div:nth-child(2) {
        color: red;
        padding: 0 3px; 
        text-decoration: underline;
        cursor: pointer;
    }
`
const ProposalDelete = styled.div`
    position: absolute;
    width: ${props => props.isDelete ? "100%" : "0"};
    height: 100%;
    top: 0;
    left: 0;
    background-color: #e94242;
    color: #fff;
    animation: ${({ isDelete }) => isDelete === null ? '': `${Animationdelete} .3s ease-in-out`};
    animation-direction: ${({ isDelete }) => isDelete ? 'normal' : 'reverse'};
    transition: all .2s ease;
    overflow: hidden;
    word-wrap: break-word; 
    color: ${props => props.isDelete ? "fff" : "transparent"};
`
const ProposalDeleteContent = styled.div`
    visibility: ${props => props.isDelete ? "visible" : "hidden"}; 
    display: grid;
    grid-template: 1fr / 4.5fr 1fr;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0 0 0 20px;
    font-size: 20px;
    font-weight: 500;
`
const ProposalDeleteRightPart = styled.div`
    display: flex;
    justify-content: space-around;
    font-weight: 300;
    span:hover {
        font-weight: 500;
        text-decoration: underline;
        cursor: pointer;
    }
`
const Edit = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    padding: 0 5px;
    ${({ large }) => large ? 'margin: 0 16px;' : ''}
    margin: 0 8px;
    color: #fff;
    font-size: 16px;
    background-color: #e94242;
    opacity: .8;
    box-shadow: 1px 2px 2px 0 rgba(153, 153, 153, 0.6);
    cursor: pointer;
`
const FilterArea = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-top: 1px solid #a0a0a0;
    padding: 15px 0;
    margin: 10px 0 0 0;
    color: #a0a0a0;
`


// WEBPACK FOOTER //
// ./src/ProposalList.js